import { useLocation, useRoutes } from "react-router-dom";
// MUI DATE PICKER
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// ALL CONTEXT FILES
// import { AuthProvider } from "app/contexts/FirebaseAuthContext";
import { AuthProvider } from "app/contexts/JWTAuthContext";
import { SettingsProvider } from "app/contexts/SettingsContext";
// THEME PROVIDER
import { MatxTheme } from "./components/MatxTheme";
// ALL ROUTES
import routes from "./routes";
import { initializeGA, trackPageView } from "./analytics";
import { useEffect } from "react";

export default function App() {
  const content = useRoutes(routes);
  const location = useLocation();

  useEffect(() => {
    initializeGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SettingsProvider>
        <MatxTheme>
          <AuthProvider>{content}</AuthProvider>
        </MatxTheme>
      </SettingsProvider>
    </LocalizationProvider>
  );
}
